import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { MHotel } from '../types'
import Marker from '../common/icons/Marker'
import ReactTooltip from "react-tooltip"

const MapMarker = ({ hotel, setHotel, setRoom, active, setPopUpOpen, current }) => {
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  return (
    <div
      className={`marker ${active ? "active" : ""} ${current ? "current" : ''}`}
      data-tip={hotel.name}
      onClick={() => {
        setHotel(hotel)
        setRoom(hotel.room_rates.rooms[0])
        setPopUpOpen(true)
      }}>
        <i><Marker width="24px" /></i>
    </div>
  )
}

MapMarker.propTypes = {
  hotel: MHotel,
  setHotel: PropTypes.func.isRequired,
  setRoom: PropTypes.func.isRequired,
  setPopUpOpen: PropTypes.func.isRequired,
  active: PropTypes.bool,
  current: PropTypes.bool
}

export default MapMarker
